export enum OrderFinishedCargoOrdersCountRequestOrder {
  CREATED_AT_DESC = "CREATED_AT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  MODIFIED_AT_DESC = "MODIFIED_AT_DESC",
  MODIFIED_AT_ASC = "MODIFIED_AT_ASC",
  START_TIME_DESC = "START_TIME_DESC",
  START_TIME_ASC = "START_TIME_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
}

export enum OrderFinishedCargoOrdersCountRequestPublicStatus {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
  PUBLISHED = "PUBLISHED",
}

export type OrderFinishedCargoOrdersCountQueryParams = {
  taxi?: string;
  driver?: string;
  isCancelled?: boolean;
  isApproved?: boolean;
  startTimeSince?: Date;
  startTimeTo?: Date;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  dispatch?: string;
  client?: string;
  externalId?: string;
  publicStatus?: OrderFinishedCargoOrdersCountRequestPublicStatus;
  order?: OrderFinishedCargoOrdersCountRequestOrder;
};

type OrderFinishedCargoOrdersCountRequest = {
  taxi?: string;
  driver?: string;
  isCancelled?: boolean;
  isApproved?: boolean;
  startTimeSince?: Date;
  startTimeTo?: Date;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  dispatch?: string;
  client?: string;
  externalId?: string;
  publicStatus?: OrderFinishedCargoOrdersCountRequestPublicStatus;
  order?: OrderFinishedCargoOrdersCountRequestOrder;
};

export default OrderFinishedCargoOrdersCountRequest;
